import { render, staticRenderFns } from "./DictPage.vue?vue&type=template&id=3a4ad0ee&"
import script from "./DictPage.vue?vue&type=script&lang=ts&"
export * from "./DictPage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports